import React, {useEffect, useState} from 'react';
import {NavLink} from 'react-router-dom';
import {Flow, FlowFetchResponse} from '../_services/Flow';
import {User} from '../_services/User';

type NavbarProps = {
    workflowId: string;
}

export const NavUserMaintenance: React.FunctionComponent<NavbarProps> = ({
                                                                 workflowId
                                                             }): JSX.Element => {
    const [form, setForm] = useState<any>();

    useEffect(() => {
        Flow.getInstance().getForm(workflowId)
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    setForm(response.json.form);
                } else {
                    throw Error(response?.json?.message || 'Error fetching Form');
                }
            })
            .catch((error: any) => {
                console.log(error);
            })
    }, [workflowId]);

    return (
        <ul className="nav nav-tabs">
            <li className="nav-item">
                <NavLink exact={true} to={`/admin/assignee-maintenance/${workflowId}`} className="nav-link" href="#">Step Assignees</NavLink>
            </li>
            {form && form.flow_form_admin_role &&
                <li className="nav-item">
                    <NavLink exact={true} to={`/admin/wfo-maintenance/${workflowId}/${form.flow_form_admin_role}`} className="nav-link" href="#">Workflow Owners</NavLink>
                </li>
            }
            {form && form.flow_form_user_role &&
                <li className="nav-item">
                    <NavLink exact={true} to={`/admin/ext-maintenance/${workflowId}/${form.flow_form_user_role}`} className="nav-link" href="#">External Users</NavLink>
                </li>
            }
            {form && form.flow_form_role_capabilities &&
                <li className="nav-item">
                    <NavLink exact={true} to={`/admin/role-maintenance/${workflowId}`} className="nav-link" href="#">Role Users</NavLink>
                </li>
            }
            <li className="nav-item">
                <NavLink exact={true} to={`/admin/dropdown-maintenance/${workflowId}`} className="nav-link" href="#">Dropdown Values</NavLink>
            </li>
            <li className="nav-item">
                <NavLink exact={true} to={`/admin/table-maintenance/${workflowId}`} className="nav-link" href="#">Tables</NavLink>
            </li>
            {User.getInstance().hasRole('is_support') &&
            <li className="nav-item">
                <NavLink exact={true} to={`/admin/configuration/${workflowId}`} className="nav-link" href="#">Configuration</NavLink>
            </li>
            }
        </ul>
    );
};
